import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class CreateLodgingProductRatePlans extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div>
                <h3 className={"mb0 mt40"}>숙박 요금제 API 생성</h3>

                <div className="blog-post-meta">
                    <span className="s-post">숙박 상품에 대한 하나 이상의 요금제 생성</span>
                    <h3 className="request-method">
                        <span className="label label-success">POST</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/lodgings/{'{travelProductId}'}/rates</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings/1234567890/rates
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Body Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        {/*<tr><td colSpan={level1}>travelProductId</td><td>X</td><td>Long</td><td>Description</td></tr>*/}

                        <tr><td colSpan={level1}>lodgingRateCreateDtos</td><td>X</td><td>List</td><td>요금 카테고리 생성</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>sellerRateId</td><td>X</td><td>String</td><td>판매자 자사사이트의 요금ID</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>sellerRoomIds</td><td>X</td><td>List</td><td>판매자 자사 사이트의 객실 ID</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>name</td><td>X</td><td>String</td><td>요금카테고리명 (관리를 위한 명칭으로 쿠팡 판매페이지에 노출되지 않습니다.)</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>saleStartedAt</td><td>O</td><td>String</td><td>투숙 기간 - 시작 (format : yyyy-MM-dd HH:mm:ss)</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>saleEndedAt</td><td>X</td><td>String</td><td>투숙 기간 - 종료 (미설정시2099-12-31 23:59:59로 설정됨. format : yyyy-MM-dd HH:mm:ss)</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>mealPolicy</td><td>X</td><td>Object</td><td>조식 정책</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>notice</td><td>X</td><td>String</td><td>조식 유의사항</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>breakfastIncluded</td><td>X</td><td>boolean</td><td>조식 포함 여부 (기본값 : False)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>numberOfGuests</td><td>O</td><td>Integer</td><td>조식 유형</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>mealStyle</td><td>X</td><td>String</td><td>조식 유형 (조식포함 여부가 True일 경우 필수 입력). Eg:직접입력,일식,양식,뷔페식,채식 </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>surchargeAvailable</td><td>X</td><td>boolean</td><td>조식 추가 요금 (기본값 : False)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>surcharges</td><td>X</td><td>List</td><td>조식 추가 요금 설정 (조식 추가 요금이 True일 경우 필수 입력)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>ageType</td><td>X</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>ADULT</td><td>성인</td></tr>
                                    <tr><td>CHILD</td><td>아동</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>minAge</td><td>X</td><td>int</td><td>어린이 요금 기준 나이 (최대 만 12세 까지 입력 가능)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>surcharge</td><td>X</td><td>double</td><td>조식 요금 입력 ('현장결제' 기준으로 요금을 설정해주세요.)</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>cancelPolicy</td><td>X</td><td>Object</td><td>취소 환불 규정</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>notice</td><td>X</td><td>String</td><td>취소 환불 규정 유의사항</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>refundable</td><td>X</td><td>boolean</td><td>환불 불가 여부 (기본값 : True)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>refundRates</td><td>X</td><td>List</td>
                            <td>일자별 취소 환불 규정 (취소 불가 여부가 True 인 경우 필수 입력 / False 인 경우 입력 불필요)<br/>
                                전액 환불의 경우 규정에 맞는 숙박일을 선택하고, 환불율은 100%로 설정해주세요.​<br/>
                                예: 숙박일= 7days, 환불율=100%로 설정하는 경우 고객이 보는 환불 규정은 취소 종류에 따라 자동 취소인 경우 "7일 23:59 전 취소 시 전액 환불", 승인 취소인 경우 "7일 17:00 전 취소 시 전액 환불"으로 보입니다.
                            </td>
                        </tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>days</td><td>O</td><td>Integer</td><td>숙박일 (예: 숙박일 5 {'{days}'}일전부터 70% {'{refundRate}'} 환불)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>refundRate</td><td>O</td><td>Double</td><td>환불율 (예: 숙박일 5 {'{days}'}일전부터 70% {'{refundRate}'} 환불)</td></tr>


                        <tr><td>&nbsp;</td><td colSpan={level2}>extraGuestPolicy</td><td>X</td><td>Object</td><td>인원 추가 비용 (입력한 인원추가요금은 각 객실의 기준인원 초과시 자동으로 적용되어 온라인으로 결제됩니다.)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>surchargeAvailable</td><td>X</td><td>boolean</td><td>인원 추가 요금 발생 여부 (기본값 : False)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>surcharges</td><td>X</td><td>List</td><td>인원 추가 요금 설정 (인원 추가 요금 발생 여부가 True인 경우 필수 입력)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>ageType</td><td>X</td><td>String</td>
                            <td><table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>ADULT</td><td>성인</td></tr>
                                <tr><td>CHILD</td><td>아동</td></tr>
                                </tbody>
                            </table></td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>minAge</td><td>X</td><td>int</td><td>어린이 요금 기준 나이 (최대 만 17세 까지 입력 가능 / (인원 추가 요금 발생 여부가 True인 경우 필수 입력))</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>surcharge</td><td>X</td><td>double</td><td>인원 추가 요금 요금 입력 (인원 추가 요금 발생 여부가 True인 경우 필수 입력)</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>extraBedPolicy</td><td>X</td><td>Object</td><td>침구 추가 요금 설정</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>extraBedAvailable</td><td>X</td><td>boolean</td><td>침구 추가 가능 여부 (기본값 : False) </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>surchargeNeeded</td><td>X</td><td>boolean</td><td>침구 추가 요금 발생 여부 (기본값 : False)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>extraBeds</td><td>X</td><td>List</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>name</td><td>X</td><td>String</td><td>침구 종류</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>bedType</td><td>X</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>ADULT</td><td>성인</td></tr>
                                    <tr><td>BABY</td><td>영아</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>surcharges</td><td>X</td><td>List</td><td>침구 추가 요금 설정 (침구 추가 요금 발생 여부가 True 경우 필수 입력)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>ageType</td><td>X</td><td>String</td>
                            <td><table className="table table-striped">
                                <tbody>
                                <tr><th>Optional Value</th><th>Description</th></tr>
                                <tr><td>ADULT</td><td>성인</td></tr>
                                <tr><td>CHILD</td><td>아동</td></tr>
                                <tr><td>BABY</td><td>영아</td></tr>
                                </tbody>
                            </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>minAge</td><td>X</td><td>int</td><td>침구 추가 요금 기준 나이 (최대 만 17세 까지 입력 가능 / (침구 추가 요금 발생 여부가 True인 경우 필수 입력))</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level5}>surcharge</td><td>X</td><td>double</td><td>침구 추가 요금 설정 (인원 추가 요금 발생 여부가 True인 경우 필수 입력)</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>checkInOutPolicy</td><td>O</td><td>Object</td><td>체크인/체크아웃 시간 </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>checkInStartTime</td><td>O</td><td>String</td><td>체크인 시간 (HH:mm)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>checkOutEndTime</td><td>O</td><td>String</td><td>체크아웃 시간 (HH:mm)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>instruction</td><td>X</td><td>String</td><td>체크인/체크아웃 안내 사항</td></tr>

                        <tr><td>&nbsp;</td><td colSpan={level2}>freeServicePolicy</td><td>X</td><td>Object</td><td>체크인/체크아웃 안내 사항</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>notice</td><td>X</td><td>String</td><td>무료 서비스 제공 유의사항</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>freeServices</td><td>X</td><td>List</td><td>무료 서비스 제공 유형 </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>freeServiceType</td><td>X</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>FREE_DRINK</td><td>무료 음료</td></tr>
                                    <tr><td>FREE_GIFT</td><td>무료 선물</td></tr>
                                    <tr><td>FREE_ROOM_UPGRADE</td><td>객실 무료 업그레이드</td></tr>
                                    <tr><td>FREE_VIEW_UPGRADE</td><td>객실 뷰 무료 업그레이드</td></tr>
                                    <tr><td>ETC</td><td>기타</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>name</td><td>X</td><td>String</td><td>무료 서비스명</td></tr>


                        <tr><td>&nbsp;</td><td colSpan={level2}>extraPackagePolicy</td><td>X</td><td>Object</td><td>패키지 설정</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>notice</td><td>X</td><td>String</td><td>패키지 유의사항</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>extraPackages</td><td>X</td><td>List</td><td>패키지 유형 선택</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>name</td><td>X</td><td>String</td><td>패키지 서비스명</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>extraPackageType</td><td>X</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>ENTRANCE_TICKET</td><td>입장권</td></tr>
                                    <tr><td>ETC</td><td>기타</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                            <a data-toggle="collapse" href = "#createTourDto">Request Body</a>
                        </div>
                        <div id = "createTourDto" className = "panel-collapse collapse">
                            <div id = "createTourDto" className="panel-body">
                    <pre className="ty01">
                        {`
{
  "lodgingRateCreateDtos": [
    {
      "cancelPolicy": {
        "notice": "cancel policy notice - 2",
        "refundRates": [
          {
            "days": 5,
            "refundRate": 90
          },
          {
            "days": 4,
            "refundRate": 80
          },
          {
            "days": 3,
            "refundRate": 50
          }
        ],
        "refundable": true
      },
      "checkInOutPolicy": {
        "checkInStartTime": "15:00",
        "checkOutEndTime": "11:00",
        "instruction": "check in/out instruction - 2"
      },
      "extraBedPolicy": {
        "extraBedAvailable": true,
        "surchargeNeeded": true,
        "extraBeds": [
          {
            "bedType": "ADULT",
            "name": "extra bed 1",
            "surcharges": [
              {
                "ageType": "ADULT",
                "minAge": 18,
                "surcharge": 80000
              }
            ]
          }
        ]
      },
      "extraGuestPolicy": {
        "surchargeAvailable": true,
        "surcharges": [
          {
            "ageType": "ADULT",
            "minAge": 18,
            "surcharge": 50000
          }
        ]
      },
      "extraPackagePolicy": {
        "extraPackages": [
          {
            "extraPackageType": "ENTRANCE_TICKET",
            "name": "Disney land"
          }
        ],
        "notice": "extra package notice"
      },
      "freeServicePolicy": {
        "freeServices": [
          {
            "freeServiceType": "FREE_DRINK",
            "name": "Welcome drink"
          }
        ],
        "notice": "free service policy notice"
      },
      "mealPolicy": {
        "breakfastIncluded": false,
        "mealStyle": "Chinese",
        "notice": "meal policy notice",
        "numberOfGuests": 2,
        "surchargeAvailable": true,
        "surcharges": [
          {
            "ageType": "CHILD",
            "minAge": 9,
            "surcharge": 10000
          }
        ]
      },
      "name": "room_rate_4",
      "saleEndedAt": "2099-12-31 23:59:59",
      "saleStartedAt": "2020-01-01 00:00:01",
      "sellerRateId": "seller rate 2",
      "sellerRoomIds": [
        "room_1",
        "room_2","room_3","room_4"
      ]
    }
  ]
}
                        `}
                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                {/*<div className="table-responsive mt40">*/}
                {/*    <h4>Response Specifications</h4>*/}
                {/*    <table className="table table-striped">*/}
                {/*        <tbody>*/}
                {/*        <tr>*/}
                {/*            <th>Name</th>*/}
                {/*            <th>Type</th>*/}
                {/*            <th>Description</th>*/}
                {/*        </tr>*/}
                {/*        <tr>*/}
                {/*            <td>code</td>*/}
                {/*            <td>String</td>*/}
                {/*            <td>응답 코드</td>*/}
                {/*        </tr>*/}
                {/*        <tr>*/}
                {/*            <td>message</td>*/}
                {/*            <td>String</td>*/}
                {/*            <td>응답 메세지</td>*/}
                {/*        </tr>*/}
                {/*        <tr>*/}
                {/*            <td>data</td>*/}
                {/*            <td>Long</td>*/}
                {/*            <td>여행상품ID</td>*/}
                {/*        </tr>*/}
                {/*        </tbody>*/}
                {/*    </table>*/}
                {/*</div>*/}
                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>data</td>
                            <td>List{'<LodgingRateResponseDto>'}</td>
                            <td></td>
                        </tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>rateId</td><td>Long</td><td>rate id</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>sellerRateId</td><td>String</td><td>셀러 웹사이트의 요금 아이디</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>name</td><td>String</td><td>요금카테고리명</td></tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "Rate plan create request successfully received",
    "data": [
        {
            "rateId": 577900851415220224,
            "sellerRateId": "seller rate 2",
            "name": "room_rate_4"
        }
    ]
}
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다
                                <div>
                                    <a data-toggle="collapse" href="#errorMessagesforCreateProduct">400 Error Messages</a>
                                </div>
                                <div id="errorMessagesforCreateProduct" className="panel-collapse collapse">
                                    <div className="panel-body">
                                        {/*<li>이넘 타입 {'${enumClazz.getSimpleName()}'}에 대한 무효 문자열 값</li>*/}
                                        {/*<li>무효 display category code  </li>*/}
                                        {/*<li>images가 비어있을 수 없음</li>*/}
                                        {/*<li>대표 이미지 단 한장만 허용 가능</li>*/}
                                        {/*<li>국내 여행에 대한 locations가 비어있으면 안됨 </li>*/}
                                        {/*<li>landNumberAddress중 하나와 roadNameAddress를 제공해야함</li>*/}
                                        {/*<li>무효 seqs  </li>*/}
                                        {/*<li>format이 IMAGE가 아닌 경우 content를 반드시 제공해야함</li>*/}
                                        {/*<li>format이 IMAGE인 경우 sellerUrl를 반드시 제공해야함</li>*/}
                                        {/*<li>travelType 및 productDetailType가 일치하지 않음</li>*/}
                                        {/*<li>instantBooking이 false인 경우 estimatedBookingDuration이 0보다 크고 72보다 작거나 같아야됨</li>*/}
                                        {/*<li>연락처에 대표 전화 번호가 하나 있어야함 </li>*/}
                                        {/*<li>무효 travel ticket feature id </li>*/}
                                        {/*<li>무효 travel ticket item feature id </li>*/}
                                        {/*<li>무효 travel ticket feature value </li>*/}
                                        {/*<li>무효 travel ticket item feature value </li>*/}
                                        {/*<li>무효 일자/시간 포맷, 포맷이 {'{pattern}'}이어야함</li>*/}
                                        {/*<li>판매 시작일은 판매 종료일보다 늦지 않아야함</li>*/}
                                        {/*<li>상품 inventoryType이 PERIOD인 경우 usePeriod가 NULL이면 안됨</li>*/}
                                        {/*<li>inventoryType이 DAILY인 경우 usePeriod가 불필요함</li>*/}
                                        {/*<li>publication은 null이 아니어야함</li>*/}
                                        {/*<li>inventoryType을 제공해야함</li>*/}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/LodgingAPIContent/LodgingProductAPI/CreateLodgingProductRatePlans.jsx